import { COUNTRIES } from '@/lib/constants/locations';

interface SelectOption {
  value: string;
  label: string;
}

/**
 * Returns country options sorted alphabetically by displayed label in the given language.
 * Ukraine is always pinned to the top for convenience.
 */
export function getSortedCountryOptions(language: string): SelectOption[] {
  const locale = language === 'uk' ? 'uk' : 'en';
  return COUNTRIES
    .map((c) => ({
      value: c.value,
      label: language === 'uk' ? c.label_ua : c.label_en,
    }))
    .sort((a, b) => {
      // Pin Ukraine to top
      if (a.value === 'UA') return -1;
      if (b.value === 'UA') return 1;
      return a.label.localeCompare(b.label, locale);
    });
}
